import React, { useState, Component } from 'react';
import { Users, BookOpen, TrendingUp, ChevronRight, ArrowLeft, User, BarChart2, Calendar, AlertTriangle, CheckCircle, TrendingDown, FileText, PieChartIcon, BarChart, LineChart, BarChart3, ChevronDown, Download, Share, Filter, ArrowUpRight, ArrowDownRight, School } from 'lucide-react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, LineChart as RechartsLineChart, Line } from 'recharts';
// Ders renkleri ve kısaltmaları
const SUBJECT_COLORS = {
  MATEMATİK: '#3b82f6',
  TÜRKÇE: '#dc2626',
  'FEN BİLİMLERİ': '#059669',
  'T.C. İNKILAP TARİHİ': '#d97706',
  'DİN KÜLTÜRÜ': '#1e3a8a',
  İNGİLİZCE: '#8b5cf6'
};
// Ders renkleri - Her ders için özel gradyan
const DERS_RENKLERI = {
  MATEMATİK: 'from-blue-600 to-blue-400',
  TÜRKÇE: 'from-red-600 to-red-400',
  'FEN BİLİMLERİ': 'from-green-600 to-green-400',
  'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK': 'from-amber-600 to-amber-400',
  'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ': 'from-teal-600 to-teal-400',
  İNGİLİZCE: 'from-purple-600 to-purple-400'
};
// Yeni veri yapıları
interface SubjectData {
  name: string;
  average: number;
  total: number;
}
interface StudentData {
  id: number;
  name: string;
  number: string;
  totalNet: number;
  averageNet: number;
  highestNet: number;
  lowestNet: number;
  lastExamNet: number;
  lastExamDate: string;
  trend: 'up' | 'down' | 'stable';
  trendValue: string;
  strongestSubject: string;
  weakestSubject: string;
  totalExams: number;
  subjects: SubjectData[];
  examHistory?: {
    date: string;
    totalNet: number;
    subjects: {
      matematik: number;
      turkce: number;
      fen: number;
      inkılap: number;
      din: number;
      ingilizce: number;
    };
  }[];
  topicPerformance?: {
    topic: string;
    success: number;
    subjectArea: 'matematik' | 'turkce' | 'fen' | 'inkılap' | 'din' | 'ingilizce';
  }[];
  subjectNets?: {
    matematik: number;
    turkce: number;
    fen: number;
    inkılap: number;
    din: number;
    ingilizce: number;
  };
}
interface ClassData {
  totalStudents: number;
  averageNet: number;
  lastExamDate: string;
  subjectData: SubjectData[];
  students: StudentData[];
}
interface ClassAnalysisData {
  [className: string]: ClassData;
}
// Mock data for class analysis
const generateClassAnalysisData = (): {
  [grade: string]: ClassAnalysisData;
} => {
  const grades = ['8. Sınıf', '7. Sınıf', '6. Sınıf', '5. Sınıf'];
  const result: {
    [grade: string]: ClassAnalysisData;
  } = {};
  grades.forEach(grade => {
    const gradeNumber = parseInt(grade.split('.')[0]);
    const classCount = gradeNumber === 8 ? 4 : gradeNumber === 7 ? 3 : 2;
    const classData: ClassAnalysisData = {};
    for (let i = 0; i < classCount; i++) {
      const className = `${gradeNumber}-${String.fromCharCode(65 + i)}`;
      const studentCount = 20 + Math.floor(Math.random() * 10);
      const averageNet = 50 + Math.floor(Math.random() * 30);
      const subjectData: SubjectData[] = [{
        name: 'MATEMATİK',
        average: 12 + Math.floor(Math.random() * 8),
        total: 20
      }, {
        name: 'TÜRKÇE',
        average: 12 + Math.floor(Math.random() * 8),
        total: 20
      }, {
        name: 'FEN BİLİMLERİ',
        average: 12 + Math.floor(Math.random() * 8),
        total: 20
      }, {
        name: 'T.C. İNKILAP TARİHİ',
        average: 6 + Math.floor(Math.random() * 4),
        total: 10
      }, {
        name: 'DİN KÜLTÜRÜ',
        average: 6 + Math.floor(Math.random() * 4),
        total: 10
      }, {
        name: 'İNGİLİZCE',
        average: 6 + Math.floor(Math.random() * 4),
        total: 10
      }];
      // Generate students
      const students: StudentData[] = [];
      for (let j = 0; j < studentCount; j++) {
        const names = ['Ahmet Yılmaz', 'Ayşe Demir', 'Mehmet Kaya', 'Zeynep Çelik', 'Mustafa Şahin', 'Elif Yıldız', 'Burak Öztürk', 'Selin Aydın', 'Cem Kılıç', 'Deniz Yılmaz', 'Emir Can', 'Gamze Demir', 'Hakan Şen', 'İrem Yücel', 'Kerem Avcı', 'Leyla Koç', 'Mert Yılmaz', 'Nisa Kara', 'Ozan Demir', 'Pınar Çetin', 'Rüzgar Yıldız', 'Sude Arslan', 'Tolga Şahin', 'Ufuk Kaya', 'Yağmur Öztürk', 'Zehra Demir', 'Ali Can', 'Berna Yılmaz', 'Canan Kılıç', 'Doruk Aydın'];
        const randomName = names[Math.floor(Math.random() * names.length)];
        const totalNet = Math.max(30, Math.min(90, Math.floor(averageNet + Math.random() * 20 - 10)));
        const highestNet = totalNet + Math.floor(Math.random() * 10);
        const lowestNet = totalNet - Math.floor(Math.random() * 10);
        const lastExamNet = totalNet + Math.floor(Math.random() * 6) - 3;
        const trend = Math.random() > 0.5 ? 'up' : 'down';
        const trendValue = (trend === 'up' ? '+' : '-') + (Math.floor(Math.random() * 5) + 1);
        const studentSubjects = subjectData.map(subject => ({
          name: subject.name,
          net: Math.max(1, Math.min(subject.total, Math.floor(subject.average + Math.random() * 6 - 3))),
          total: subject.total
        }));
        // Calculate strongest and weakest subjects
        let strongestSubject = 'MATEMATİK';
        let weakestSubject = 'MATEMATİK';
        let highestPercentage = 0;
        let lowestPercentage = 100;
        studentSubjects.forEach(subject => {
          const percentage = subject.net / subject.total * 100;
          if (percentage > highestPercentage) {
            highestPercentage = percentage;
            strongestSubject = subject.name;
          }
          if (percentage < lowestPercentage) {
            lowestPercentage = percentage;
            weakestSubject = subject.name;
          }
        });
        // Create subjectNets for compatibility
        const subjectNets = {
          matematik: studentSubjects.find(s => s.name === 'MATEMATİK')?.net || 0,
          turkce: studentSubjects.find(s => s.name === 'TÜRKÇE')?.net || 0,
          fen: studentSubjects.find(s => s.name === 'FEN BİLİMLERİ')?.net || 0,
          inkılap: studentSubjects.find(s => s.name === 'T.C. İNKILAP TARİHİ')?.net || 0,
          din: studentSubjects.find(s => s.name === 'DİN KÜLTÜRÜ')?.net || 0,
          ingilizce: studentSubjects.find(s => s.name === 'İNGİLİZCE')?.net || 0
        };
        // Generate exam history
        const examHistory = [{
          date: '2024-01-15',
          totalNet: lastExamNet - 6,
          subjects: {
            matematik: subjectNets.matematik - 2,
            turkce: subjectNets.turkce - 1,
            fen: subjectNets.fen - 1,
            inkılap: subjectNets.inkılap - 1,
            din: subjectNets.din - 0.5,
            ingilizce: subjectNets.ingilizce - 0.5
          }
        }, {
          date: '2024-02-01',
          totalNet: lastExamNet - 3,
          subjects: {
            matematik: subjectNets.matematik - 1,
            turkce: subjectNets.turkce - 0.5,
            fen: subjectNets.fen - 0.5,
            inkılap: subjectNets.inkılap - 0.5,
            din: subjectNets.din - 0.25,
            ingilizce: subjectNets.ingilizce - 0.25
          }
        }, {
          date: '2024-02-15',
          totalNet: lastExamNet,
          subjects: {
            matematik: subjectNets.matematik,
            turkce: subjectNets.turkce,
            fen: subjectNets.fen,
            inkılap: subjectNets.inkılap,
            din: subjectNets.din,
            ingilizce: subjectNets.ingilizce
          }
        }];
        // Generate topic performance
        const topicPerformance = [{
          topic: 'Üslü Sayılar',
          success: 70 + Math.floor(Math.random() * 30),
          subjectArea: 'matematik' as const
        }, {
          topic: 'Köklü Sayılar',
          success: 70 + Math.floor(Math.random() * 30),
          subjectArea: 'matematik' as const
        }, {
          topic: 'Sözcükte Anlam',
          success: 70 + Math.floor(Math.random() * 30),
          subjectArea: 'turkce' as const
        }, {
          topic: 'Paragraf',
          success: 70 + Math.floor(Math.random() * 30),
          subjectArea: 'turkce' as const
        }, {
          topic: 'Kuvvet ve Hareket',
          success: 70 + Math.floor(Math.random() * 30),
          subjectArea: 'fen' as const
        }, {
          topic: 'Madde ve Endüstri',
          success: 70 + Math.floor(Math.random() * 30),
          subjectArea: 'fen' as const
        }];
        students.push({
          id: j + 1,
          name: randomName,
          number: (j + 1).toString().padStart(2, '0'),
          totalNet: lastExamNet,
          averageNet: totalNet,
          highestNet,
          lowestNet,
          lastExamNet,
          lastExamDate: '2024-02-15',
          trend,
          trendValue,
          strongestSubject,
          weakestSubject,
          totalExams: 8,
          subjects: studentSubjects,
          examHistory,
          topicPerformance,
          subjectNets
        });
      }
      classData[className] = {
        totalStudents: studentCount,
        averageNet,
        lastExamDate: '2024-02-15',
        subjectData,
        students
      };
    }
    result[grade] = classData;
  });
  return result;
};
// Generate mock data
const allClassData = generateClassAnalysisData();
// 8 Denemenin Tam İstatistikleri
const allExamsData = [{
  id: 'lgs8',
  name: 'LGS 8',
  date: '2024-01-30',
  totalCorrect: 85,
  totalWrong: 3,
  totalEmpty: 2,
  totalNet: 84,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 19,
    wrong: 0,
    empty: 1,
    net: 19,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 4,
      wrong: 0,
      empty: 1,
      net: 4,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 19,
    wrong: 1,
    empty: 0,
    net: 18.67,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 1,
      empty: 0,
      net: 2.67,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 9,
    wrong: 1,
    empty: 0,
    net: 8.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs7',
  name: 'LGS 7',
  date: '2023-12-15',
  totalCorrect: 80,
  totalWrong: 5,
  totalEmpty: 5,
  totalNet: 78.33,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 17,
    wrong: 2,
    empty: 1,
    net: 16.33,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 1,
      empty: 1,
      net: 2.67,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 18,
    wrong: 1,
    empty: 1,
    net: 17.67,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 0,
      empty: 1,
      net: 3,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 9,
    wrong: 1,
    empty: 0,
    net: 8.67,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 10,
    wrong: 0,
    empty: 0,
    net: 10,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs6',
  name: 'LGS 6',
  date: '2023-12-01',
  totalCorrect: 78,
  totalWrong: 6,
  totalEmpty: 6,
  totalNet: 76,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 17,
    wrong: 2,
    empty: 1,
    net: 16.33,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 1,
      empty: 1,
      net: 2.67,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 17,
    wrong: 2,
    empty: 1,
    net: 16.33,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 0,
      empty: 1,
      net: 3,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 9,
    wrong: 1,
    empty: 0,
    net: 8.67,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 9,
    wrong: 0,
    empty: 1,
    net: 9,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }]
  }]
}, {
  id: 'lgs5',
  name: 'LGS 5',
  date: '2023-11-15',
  totalCorrect: 75,
  totalWrong: 8,
  totalEmpty: 7,
  totalNet: 72.33,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 15,
    wrong: 3,
    empty: 2,
    net: 14,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 0,
      empty: 2,
      net: 3,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 16,
    wrong: 2,
    empty: 2,
    net: 15.33,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 0,
      empty: 1,
      net: 3,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 3,
      wrong: 0,
      empty: 0,
      net: 3,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 7,
    wrong: 2,
    empty: 1,
    net: 6.33,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 9,
    wrong: 1,
    empty: 0,
    net: 8.67,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'Science',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs4',
  name: 'LGS 4',
  date: '2023-11-01',
  totalCorrect: 70,
  totalWrong: 10,
  totalEmpty: 10,
  totalNet: 66.67,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 14,
    wrong: 4,
    empty: 2,
    net: 12.67,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 15,
    wrong: 3,
    empty: 2,
    net: 14,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 0,
      empty: 2,
      net: 3,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 15,
    wrong: 2,
    empty: 3,
    net: 14.33,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 3,
      wrong: 0,
      empty: 1,
      net: 3,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 8,
    wrong: 0,
    empty: 2,
    net: 8,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 8,
    wrong: 1,
    empty: 1,
    net: 7.67,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs3',
  name: 'LGS 3',
  date: '2023-10-15',
  totalCorrect: 68,
  totalWrong: 12,
  totalEmpty: 10,
  totalNet: 64,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 13,
    wrong: 4,
    empty: 3,
    net: 11.67,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 1,
      wrong: 2,
      empty: 0,
      net: 0.33,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 14,
    wrong: 4,
    empty: 2,
    net: 12.67,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 1,
      empty: 1,
      net: 2.67,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 14,
    wrong: 3,
    empty: 3,
    net: 13,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 2,
      wrong: 1,
      empty: 1,
      net: 1.67,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 6,
    wrong: 2,
    empty: 2,
    net: 5.33,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 8,
    wrong: 2,
    empty: 0,
    net: 7.33,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }]
}, {
  id: 'lgs2',
  name: 'LGS 2',
  date: '2023-10-01',
  totalCorrect: 65,
  totalWrong: 15,
  totalEmpty: 10,
  totalNet: 60,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 12,
    wrong: 5,
    empty: 3,
    net: 10.33,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 1,
      wrong: 2,
      empty: 0,
      net: 0.33,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 0,
      wrong: 2,
      empty: 0,
      net: -0.67,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 13,
    wrong: 5,
    empty: 2,
    net: 11.33,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 1,
      wrong: 2,
      empty: 0,
      net: 0.33,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 1,
      empty: 1,
      net: 2.67,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 13,
    wrong: 3,
    empty: 4,
    net: 12,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 2,
      wrong: 1,
      empty: 1,
      net: 1.67,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 6,
    wrong: 2,
    empty: 2,
    net: 5.33,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 8,
    wrong: 0,
    empty: 2,
    net: 8,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }]
  }]
}, {
  id: 'lgs1',
  name: 'LGS 1',
  date: '2023-09-15',
  totalCorrect: 60,
  totalWrong: 18,
  totalEmpty: 12,
  totalNet: 54,
  subjects: [{
    subject: 'MATEMATİK',
    correct: 10,
    wrong: 6,
    empty: 4,
    net: 8,
    questions: 20,
    topics: [{
      topic: 'Çarpanlar ve Katlar',
      correct: 1,
      wrong: 2,
      empty: 0,
      net: 0.33,
      questions: 3
    }, {
      topic: 'Üslü Sayılar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Köklü Sayılar',
      correct: 0,
      wrong: 2,
      empty: 0,
      net: -0.67,
      questions: 2
    }, {
      topic: 'Veri Analizi',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Olasılık',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Cebirsel İfadeler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Doğrusal Denklemler ve Eğim',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }, {
      topic: 'Eşitsizlikler',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Üçgenler',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Eşlik ve Benzerlik',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Dönüşüm Geometrisi',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'TÜRKÇE',
    correct: 12,
    wrong: 6,
    empty: 2,
    net: 10,
    questions: 20,
    topics: [{
      topic: 'Sözcükte Anlam',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Deyimler ve Atasözleri',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Cümlede Anlam',
      correct: 1,
      wrong: 2,
      empty: 0,
      net: 0.33,
      questions: 3
    }, {
      topic: 'Sözel Mantık / Görsel Okuma',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Parçada Anlam',
      correct: 3,
      wrong: 2,
      empty: 0,
      net: 2.33,
      questions: 5
    }, {
      topic: 'Söz Sanatları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Metin Türleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Noktalama İşaretleri',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Yazım Kuralları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Fiilimsiler',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Cümlenin Öğeleri',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }]
  }, {
    subject: 'FEN BİLİMLERİ',
    correct: 12,
    wrong: 4,
    empty: 4,
    net: 10.67,
    questions: 20,
    topics: [{
      topic: 'Mevsimler ve İklim',
      correct: 1,
      wrong: 2,
      empty: 0,
      net: 0.33,
      questions: 3
    }, {
      topic: 'DNA ve Genetik Kod',
      correct: 2,
      wrong: 1,
      empty: 0,
      net: 1.67,
      questions: 3
    }, {
      topic: 'Basınç',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Madde ve Endüstri',
      correct: 2,
      wrong: 1,
      empty: 1,
      net: 1.67,
      questions: 4
    }, {
      topic: 'Basit Makineler',
      correct: 2,
      wrong: 0,
      empty: 1,
      net: 2,
      questions: 3
    }, {
      topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
      correct: 2,
      wrong: 0,
      empty: 0,
      net: 2,
      questions: 2
    }]
  }, {
    subject: 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK',
    correct: 5,
    wrong: 3,
    empty: 2,
    net: 4,
    questions: 10,
    topics: [{
      topic: 'Bir Kahraman Doğuyor',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
      correct: 1,
      wrong: 0,
      empty: 1,
      net: 1,
      questions: 2
    }, {
      topic: 'Demokratikleşme Çabaları',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Atatürk Dönemi Dış Politika',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: "Atatürk'ün Ölümü ve Sonrası",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ',
    correct: 6,
    wrong: 2,
    empty: 2,
    net: 5.33,
    questions: 10,
    topics: [{
      topic: 'Kader İnancı',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Zekat ve Sadaka',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Din ve Hayat',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: "Hz. Muhammed'in Örnekliği",
      correct: 1,
      wrong: 1,
      empty: 0,
      net: 0.67,
      questions: 2
    }, {
      topic: "Kur'an-ı Kerim ve Özellikleri",
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'İslam Dinine Göre Kötü Davranışlar',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }]
  }, {
    subject: 'İNGİLİZCE',
    correct: 7,
    wrong: 1,
    empty: 2,
    net: 6.67,
    questions: 10,
    topics: [{
      topic: 'Friendship',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Teen Life',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'In The Kitchen',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'On The Phone',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'The Internet',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Adventures',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Tourism',
      correct: 0,
      wrong: 1,
      empty: 0,
      net: -0.33,
      questions: 1
    }, {
      topic: 'Chores',
      correct: 1,
      wrong: 0,
      empty: 0,
      net: 1,
      questions: 1
    }, {
      topic: 'Science',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }, {
      topic: 'Natural Forces',
      correct: 0,
      wrong: 0,
      empty: 1,
      net: 0,
      questions: 1
    }]
  }]
}];
// Add topic analysis data for all subjects
const topicAnalysisData = {
  MATEMATİK: [{
    topic: 'Çarpanlar ve Katlar',
    correct: 45,
    wrong: 3,
    empty: 0,
    totalQuestions: 48,
    accuracy: 93.75,
    errorCount: 3
  }, {
    topic: 'Üslü Sayılar',
    correct: 42,
    wrong: 4,
    empty: 2,
    totalQuestions: 48,
    accuracy: 87.5,
    errorCount: 4
  }, {
    topic: 'Köklü Sayılar',
    correct: 40,
    wrong: 5,
    empty: 3,
    totalQuestions: 48,
    accuracy: 83.33,
    errorCount: 5
  }, {
    topic: 'Veri Analizi',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67,
    errorCount: 2
  }, {
    topic: 'Olasılık',
    correct: 20,
    wrong: 3,
    empty: 1,
    totalQuestions: 24,
    accuracy: 83.33,
    errorCount: 3
  }, {
    topic: 'Cebirsel İfadeler',
    correct: 36,
    wrong: 9,
    empty: 3,
    totalQuestions: 48,
    accuracy: 75.0,
    errorCount: 9
  }, {
    topic: 'Doğrusal Denklemler ve Eğim',
    correct: 38,
    wrong: 7,
    empty: 3,
    totalQuestions: 48,
    accuracy: 79.17,
    errorCount: 7
  }, {
    topic: 'Eşitsizlikler',
    correct: 16,
    wrong: 6,
    empty: 2,
    totalQuestions: 24,
    accuracy: 66.67,
    errorCount: 6
  }, {
    topic: 'Üçgenler',
    correct: 32,
    wrong: 7,
    empty: 1,
    totalQuestions: 40,
    accuracy: 80.0,
    errorCount: 7
  }, {
    topic: 'Eşlik ve Benzerlik',
    correct: 18,
    wrong: 4,
    empty: 2,
    totalQuestions: 24,
    accuracy: 75.0,
    errorCount: 4
  }, {
    topic: 'Dönüşüm Geometrisi',
    correct: 16,
    wrong: 5,
    empty: 3,
    totalQuestions: 24,
    accuracy: 66.67,
    errorCount: 5
  }, {
    topic: 'Geometrik Cisimler',
    correct: 25,
    wrong: 6,
    empty: 1,
    totalQuestions: 32,
    accuracy: 78.13,
    errorCount: 6
  }],
  TÜRKÇE: [{
    topic: 'Sözcükte Anlam',
    correct: 38,
    wrong: 2,
    empty: 0,
    totalQuestions: 40,
    accuracy: 95.0,
    errorCount: 2
  }, {
    topic: 'Deyimler ve Atasözleri',
    correct: 35,
    wrong: 3,
    empty: 2,
    totalQuestions: 40,
    accuracy: 87.5,
    errorCount: 3
  }, {
    topic: 'Cümlede Anlam',
    correct: 37,
    wrong: 3,
    empty: 0,
    totalQuestions: 40,
    accuracy: 92.5,
    errorCount: 3
  }, {
    topic: 'Sözel Mantık / Görsel Okuma',
    correct: 28,
    wrong: 4,
    empty: 0,
    totalQuestions: 32,
    accuracy: 87.5,
    errorCount: 4
  }, {
    topic: 'Parçada Anlam',
    correct: 55,
    wrong: 7,
    empty: 2,
    totalQuestions: 64,
    accuracy: 85.94,
    errorCount: 7
  }, {
    topic: 'Söz Sanatları',
    correct: 20,
    wrong: 3,
    empty: 1,
    totalQuestions: 24,
    accuracy: 83.33,
    errorCount: 3
  }, {
    topic: 'Metin Türleri',
    correct: 28,
    wrong: 3,
    empty: 1,
    totalQuestions: 32,
    accuracy: 87.5,
    errorCount: 3
  }, {
    topic: 'Noktalama İşaretleri',
    correct: 25,
    wrong: 2,
    empty: 1,
    totalQuestions: 28,
    accuracy: 89.29,
    errorCount: 2
  }, {
    topic: 'Yazım Kuralları',
    correct: 26,
    wrong: 4,
    empty: 2,
    totalQuestions: 32,
    accuracy: 81.25,
    errorCount: 4
  }, {
    topic: 'Fiilimsiler',
    correct: 15,
    wrong: 6,
    empty: 3,
    totalQuestions: 24,
    accuracy: 62.5,
    errorCount: 6
  }, {
    topic: 'Cümlenin Öğeleri',
    correct: 30,
    wrong: 5,
    empty: 1,
    totalQuestions: 36,
    accuracy: 83.33,
    errorCount: 5
  }, {
    topic: 'Cümle Türleri',
    correct: 22,
    wrong: 7,
    empty: 3,
    totalQuestions: 32,
    accuracy: 68.75,
    errorCount: 7
  }, {
    topic: 'Anlatım Bozukluğu',
    correct: 14,
    wrong: 9,
    empty: 1,
    totalQuestions: 24,
    accuracy: 58.33,
    errorCount: 9
  }],
  'FEN BİLİMLERİ': [{
    topic: 'Mevsimler ve İklim',
    correct: 25,
    wrong: 3,
    empty: 0,
    totalQuestions: 28,
    accuracy: 89.29,
    errorCount: 3
  }, {
    topic: 'DNA ve Genetik Kod',
    correct: 38,
    wrong: 4,
    empty: 2,
    totalQuestions: 44,
    accuracy: 86.36,
    errorCount: 4
  }, {
    topic: 'Basınç',
    correct: 18,
    wrong: 4,
    empty: 2,
    totalQuestions: 24,
    accuracy: 75.0,
    errorCount: 4
  }, {
    topic: 'Madde ve Endüstri',
    correct: 32,
    wrong: 10,
    empty: 2,
    totalQuestions: 44,
    accuracy: 72.73,
    errorCount: 10
  }, {
    topic: 'Basit Makineler',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67,
    errorCount: 2
  }, {
    topic: 'Enerji Dönüşümleri ve Çevre Bilimi',
    correct: 28,
    wrong: 3,
    empty: 1,
    totalQuestions: 32,
    accuracy: 87.5,
    errorCount: 3
  }, {
    topic: 'Elektrik Yükleri ve Elektrik Enerjisi',
    correct: 28,
    wrong: 7,
    empty: 1,
    totalQuestions: 36,
    accuracy: 77.78,
    errorCount: 7
  }],
  'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK': [{
    topic: 'Bir Kahraman Doğuyor',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67,
    errorCount: 2
  }, {
    topic: 'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
    correct: 34,
    wrong: 4,
    empty: 2,
    totalQuestions: 40,
    accuracy: 85.0,
    errorCount: 4
  }, {
    topic: 'Milli Bir Destan: Ya İstiklal, Ya Ölüm',
    correct: 30,
    wrong: 6,
    empty: 0,
    totalQuestions: 36,
    accuracy: 83.33,
    errorCount: 6
  }, {
    topic: 'Atatürkçülük ve Çağdaşlaşan Türkiye',
    correct: 25,
    wrong: 3,
    empty: 0,
    totalQuestions: 28,
    accuracy: 89.29,
    errorCount: 3
  }, {
    topic: 'Demokratikleşme Çabaları',
    correct: 15,
    wrong: 2,
    empty: 1,
    totalQuestions: 18,
    accuracy: 83.33,
    errorCount: 2
  }, {
    topic: 'Atatürk Dönemi Dış Politika',
    correct: 12,
    wrong: 6,
    empty: 0,
    totalQuestions: 18,
    accuracy: 66.67,
    errorCount: 6
  }, {
    topic: "Atatürk'ün Ölümü ve Sonrası",
    correct: 12,
    wrong: 2,
    empty: 1,
    totalQuestions: 15,
    accuracy: 80.0,
    errorCount: 2
  }],
  'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ': [{
    topic: 'Kader İnancı',
    correct: 22,
    wrong: 2,
    empty: 0,
    totalQuestions: 24,
    accuracy: 91.67,
    errorCount: 2
  }, {
    topic: 'Bir Peygamber Tanıyorum: Hz. Musa',
    correct: 16,
    wrong: 2,
    empty: 0,
    totalQuestions: 18,
    accuracy: 88.89,
    errorCount: 2
  }, {
    topic: 'Zekat ve Sadaka',
    correct: 14,
    wrong: 1,
    empty: 0,
    totalQuestions: 15,
    accuracy: 93.33,
    errorCount: 1
  }, {
    topic: 'Din ve Hayat',
    correct: 18,
    wrong: 2,
    empty: 1,
    totalQuestions: 21,
    accuracy: 85.71,
    errorCount: 2
  }, {
    topic: "Hz. Muhammed'in Örnekliği",
    correct: 25,
    wrong: 2,
    empty: 0,
    totalQuestions: 27,
    accuracy: 92.59,
    errorCount: 2
  }, {
    topic: "Kur'an-ı Kerim ve Özellikleri",
    correct: 20,
    wrong: 3,
    empty: 1,
    totalQuestions: 24,
    accuracy: 83.33,
    errorCount: 3
  }, {
    topic: "İslam'ın Paylaşma ve Yardımlaşmaya Verdiği Önem",
    correct: 16,
    wrong: 1,
    empty: 1,
    totalQuestions: 18,
    accuracy: 88.89,
    errorCount: 1
  }, {
    topic: 'İslam Dinine Göre Kötü Davranışlar',
    correct: 12,
    wrong: 5,
    empty: 1,
    totalQuestions: 18,
    accuracy: 66.67,
    errorCount: 5
  }, {
    topic: 'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
    correct: 13,
    wrong: 2,
    empty: 0,
    totalQuestions: 15,
    accuracy: 86.67,
    errorCount: 2
  }, {
    topic: 'Hac ibadeti',
    correct: 12,
    wrong: 3,
    empty: 3,
    totalQuestions: 18,
    accuracy: 66.67,
    errorCount: 3
  }],
  İNGİLİZCE: [{
    topic: 'Friendship',
    correct: 18,
    wrong: 2,
    empty: 0,
    totalQuestions: 20,
    accuracy: 90.0,
    errorCount: 2
  }, {
    topic: 'Teen Life',
    correct: 19,
    wrong: 2,
    empty: 1,
    totalQuestions: 22,
    accuracy: 86.36,
    errorCount: 2
  }, {
    topic: 'In The Kitchen',
    correct: 14,
    wrong: 1,
    empty: 0,
    totalQuestions: 15,
    accuracy: 93.33,
    errorCount: 1
  }, {
    topic: 'On The Phone',
    correct: 15,
    wrong: 3,
    empty: 0,
    totalQuestions: 18,
    accuracy: 83.33,
    errorCount: 3
  }, {
    topic: 'The Internet',
    correct: 20,
    wrong: 4,
    empty: 0,
    totalQuestions: 24,
    accuracy: 83.33,
    errorCount: 4
  }, {
    topic: 'Adventures',
    correct: 16,
    wrong: 3,
    empty: 1,
    totalQuestions: 20,
    accuracy: 80.0,
    errorCount: 3
  }, {
    topic: 'Tourism',
    correct: 14,
    wrong: 2,
    empty: 2,
    totalQuestions: 18,
    accuracy: 77.78,
    errorCount: 2
  }, {
    topic: 'Chores',
    correct: 12,
    wrong: 1,
    empty: 2,
    totalQuestions: 15,
    accuracy: 80.0,
    errorCount: 1
  }, {
    topic: 'Science',
    correct: 22,
    wrong: 4,
    empty: 1,
    totalQuestions: 27,
    accuracy: 81.48,
    errorCount: 4
  }, {
    topic: 'Natural Forces',
    correct: 18,
    wrong: 3,
    empty: 3,
    totalQuestions: 24,
    accuracy: 75.0,
    errorCount: 3
  }]
};
// Grafik için sıralı veri
const lgsExamData = allExamsData.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()).map(exam => ({
  name: exam.name,
  date: exam.date,
  net: exam.totalNet,
  maxNet: 90
}));
// Custom tooltip for charts - Updated to show net values
const CustomTooltip = ({
  active,
  payload,
  label
}) => {
  if (active && payload && payload.length) {
    return <div className="p-3 bg-gray-900 border border-gray-700 rounded-lg shadow-lg" data-id="element-87">
        <p className="text-sm font-medium text-white" data-id="element-88">{label}</p>
        {payload.map((entry, index) => entry.name !== 'Maksimum Net' && <p key={index} className="text-sm" style={{
        color: entry.color
      }} data-id="element-89">
                Net: {entry.value}
              </p>)}
      </div>;
  }
  return null;
};
// Step 1: Grade Selection Component
const GradeSelection = ({
  onGradeSelect
}: {
  onGradeSelect: (grade: string) => void;
}) => {
  const [selectedGrade, setSelectedGrade] = useState('8. Sınıf');
  const handleGradeSelect = (grade: string) => {
    setSelectedGrade(grade);
    onGradeSelect(grade);
  };
  return <div className="space-y-6" data-id="element-90">
      <div className="flex items-center gap-3 mb-6" data-id="element-91">
        <BookOpen className="w-8 h-8 text-emerald-400" data-id="element-92" />
        <h1 className="text-2xl font-bold" data-id="element-93">Sınav Analizleri</h1>
      </div>
      {/* Sınıf Seviyesi Seçimi */}
      <div className="flex flex-wrap gap-4 mb-6" data-id="element-94">
        {['8. Sınıf', '7. Sınıf', '6. Sınıf', '5. Sınıf'].map(grade => <button key={grade} onClick={() => handleGradeSelect(grade)} className={`px-6 py-3 rounded-lg font-medium transition-colors ${selectedGrade === grade ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white' : 'bg-white/5 text-gray-400 hover:text-white hover:bg-white/10'}`} data-id="element-95">
            {grade}
          </button>)}
      </div>
      {/* Sınıf Kartları */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-96">
        {Object.keys(allClassData[selectedGrade]).map(className => {
        const classInfo = allClassData[selectedGrade][className];
        return <div key={className} onClick={() => onGradeSelect(selectedGrade, className)} className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600 cursor-pointer hover:shadow-[0_0_15px_rgba(16,185,129,0.3)] hover:scale-[1.02] transition-all duration-300" data-id="element-97">
              <div className="bg-black/90 rounded-xl p-6" data-id="element-98">
                {/* Sınıf Bilgisi */}
                <div className="flex items-center justify-between mb-4" data-id="element-99">
                  <div className="flex items-center gap-3" data-id="element-100">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-emerald-600 to-teal-600 flex items-center justify-center" data-id="element-101">
                      <School className="w-6 h-6 text-white" data-id="element-102" />
                    </div>
                    <div data-id="element-103">
                      <h3 className="text-xl font-bold text-white" data-id="element-104">
                        {className}
                      </h3>
                      <span className="text-gray-400" data-id="element-105">
                        {classInfo.totalStudents} öğrenci
                      </span>
                    </div>
                  </div>
                  <ChevronRight className="w-6 h-6 text-emerald-400" data-id="element-106" />
                </div>
                {/* Sınıf Ortalaması */}
                <div className="text-center mb-4" data-id="element-107">
                  <div className="text-sm text-gray-400 mb-1" data-id="element-108">
                    Sınıf Ortalaması
                  </div>
                  <div className="text-3xl font-bold text-emerald-400" data-id="element-109">
                    {classInfo.averageNet} <span className="text-lg" data-id="element-110">net</span>
                  </div>
                </div>
                {/* Mini Pie Chart */}
                <div className="w-32 h-32 mx-auto mb-4" data-id="element-111">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-112">
                    <PieChart data-id="element-113">
                      <Pie data={classInfo.subjectData} cx="50%" cy="50%" innerRadius={25} outerRadius={50} paddingAngle={2} dataKey="average" data-id="element-114">
                        {classInfo.subjectData.map((entry, index) => <Cell key={`cell-${index}`} fill={SUBJECT_COLORS[entry.name]} data-id="element-115" />)}
                      </Pie>
                      <Tooltip content={({
                    active,
                    payload
                  }) => {
                    if (active && payload && payload.length) {
                      const data = payload[0].payload;
                      return <div className="bg-black border border-emerald-500/30 rounded-lg p-3 shadow-lg" data-id="element-117">
                                <p className="text-white font-medium" data-id="element-118">
                                  {data.name}
                                </p>
                                <p className="text-emerald-400" data-id="element-119">
                                  {data.average} net / {data.total}
                                </p>
                              </div>;
                    }
                    return null;
                  }} data-id="element-116" />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
                {/* Ders Bazlı Net Listesi */}
                <div className="space-y-2" data-id="element-120">
                  {classInfo.subjectData.map(subject => <div key={subject.name} className="flex justify-between items-center text-sm" data-id="element-121">
                      <div className="flex items-center gap-2" data-id="element-122">
                        <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: SUBJECT_COLORS[subject.name]
                  }} data-id="element-123" />
                        <span className="text-gray-300" data-id="element-124">{subject.name}</span>
                      </div>
                      <span className="text-white font-medium" data-id="element-125">
                        {subject.average}/{subject.total}
                      </span>
                    </div>)}
                </div>
                {/* Son Sınav Tarihi */}
                <div className="mt-4 pt-4 border-t border-gray-800 text-center" data-id="element-126">
                  <span className="text-xs text-gray-400" data-id="element-127">
                    Son Sınav: {classInfo.lastExamDate}
                  </span>
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
};
// Step 2: Class Students Component
const ClassStudents = ({
  grade,
  className,
  classData,
  onBack,
  onStudentSelect
}: {
  grade: string;
  className: string;
  classData: ClassData;
  onBack: () => void;
  onStudentSelect: (student: StudentData) => void;
}) => {
  const [sortOption, setSortOption] = useState('net-desc');
  const [searchQuery, setSearchQuery] = useState('');
  // Sort and filter students
  const sortedStudents = [...classData.students].filter(student => student.name.toLowerCase().includes(searchQuery.toLowerCase())).sort((a, b) => {
    switch (sortOption) {
      case 'net-desc':
        return b.lastExamNet - a.lastExamNet;
      case 'net-asc':
        return a.lastExamNet - b.lastExamNet;
      case 'name-asc':
        return a.name.localeCompare(b.name);
      case 'name-desc':
        return b.name.localeCompare(a.name);
      case 'number-asc':
        return parseInt(a.number) - parseInt(b.number);
      case 'number-desc':
        return parseInt(b.number) - parseInt(a.number);
      default:
        return 0;
    }
  });
  return <div className="space-y-6" data-id="element-128">
      {/* Sınıf Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6" data-id="element-129">
        <div className="flex items-center gap-4" data-id="element-130">
          <button onClick={onBack} className="flex items-center gap-2 px-4 py-2 rounded-lg border border-white text-white hover:bg-white/10 transition-all" data-id="element-131">
            <ArrowLeft className="w-5 h-5" data-id="element-132" />
            Sınıf Listesi
          </button>
          <div data-id="element-133">
            <h1 className="text-2xl font-bold text-white" data-id="element-134">
              {className} - Öğrenci Analizleri
            </h1>
            <p className="text-gray-400" data-id="element-135">
              {classData.students.length} Öğrenci • Sınıf Ort:{' '}
              {classData.averageNet} net
            </p>
          </div>
        </div>
        {/* Arama ve Sıralama */}
        <div className="flex flex-wrap gap-2" data-id="element-136">
          <div className="relative" data-id="element-137">
            <input type="text" placeholder="Öğrenci ara..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="bg-white/5 text-white rounded-lg px-4 py-2 pl-10 border border-emerald-500/30 focus:border-emerald-500/50 focus:outline-none" data-id="element-138" />
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2" data-id="element-139">
              <Filter className="w-4 h-4 text-gray-400" data-id="element-140" />
            </div>
          </div>
          <select value={sortOption} onChange={e => setSortOption(e.target.value)} className="bg-white/5 text-white rounded-lg px-4 py-2 border border-emerald-500/30 focus:border-emerald-500/50 focus:outline-none" data-id="element-141">
            <option value="net-desc" data-id="element-142">Net (Yüksek → Alçak)</option>
            <option value="net-asc" data-id="element-143">Net (Alçak → Yüksek)</option>
            <option value="name-asc" data-id="element-144">İsim (A → Z)</option>
            <option value="name-desc" data-id="element-145">İsim (Z → A)</option>
            <option value="number-asc" data-id="element-146">Numara (1 → 99)</option>
            <option value="number-desc" data-id="element-147">Numara (99 → 1)</option>
          </select>
        </div>
      </div>
      {/* Öğrenci Kartları */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-148">
        {sortedStudents.map(student => <div key={student.id} onClick={() => onStudentSelect(student)} className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600 cursor-pointer hover:scale-[1.02] transition-transform duration-200" data-id="element-149">
            <div className="bg-black/90 rounded-lg p-4" data-id="element-150">
              {/* Öğrenci Bilgisi */}
              <div className="flex items-center gap-3 mb-3" data-id="element-151">
                <div className="w-10 h-10 rounded-full bg-gradient-to-r from-emerald-600 to-teal-600 flex items-center justify-center" data-id="element-152">
                  <span className="text-white font-bold" data-id="element-153">
                    {student.name[0]}
                  </span>
                </div>
                <div className="flex-1" data-id="element-154">
                  <h3 className="text-white font-medium" data-id="element-155">{student.name}</h3>
                  <span className="text-gray-400 text-sm" data-id="element-156">
                    No: {student.number}
                  </span>
                </div>
                <div className="text-right" data-id="element-157">
                  <div className="text-lg font-bold text-emerald-400" data-id="element-158">
                    {student.lastExamNet}
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-159">net</div>
                </div>
              </div>
              {/* Mini Progress Bar */}
              <div className="space-y-1" data-id="element-160">
                {student.subjects.slice(0, 3).map(subject => <div key={subject.name} className="flex items-center gap-2 text-xs" data-id="element-161">
                    <div className="w-2 h-2 rounded-full" style={{
                backgroundColor: SUBJECT_COLORS[subject.name]
              }} data-id="element-162" />
                    <span className="text-gray-400 flex-1" data-id="element-163">{subject.name}</span>
                    <span className="text-white" data-id="element-164">
                      {subject.net}/{subject.total}
                    </span>
                  </div>)}
                {student.subjects.length > 3 && <div className="text-xs text-gray-500 text-center" data-id="element-165">
                    +{student.subjects.length - 3} ders daha
                  </div>}
              </div>
              {/* Son Performans */}
              <div className="mt-3 pt-3 border-t border-gray-800 flex justify-between items-center" data-id="element-166">
                <span className="text-xs text-gray-400" data-id="element-167">
                  Son Sınav: {student.lastExamDate}
                </span>
                <div className="flex items-center gap-1 text-xs" data-id="element-168">
                  {student.trend === 'up' ? <ArrowUpRight className="w-3 h-3 text-green-400" data-id="element-169" /> : <ArrowDownRight className="w-3 h-3 text-red-400" data-id="element-170" />}
                  <span className={student.trend === 'up' ? 'text-green-400' : 'text-red-400'} data-id="element-171">
                    {student.trendValue}
                  </span>
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};
// Step 3: Student Detailed Analysis Component
function StudentDetailedAnalysis({
  grade,
  className,
  studentData,
  onBack
}: {
  grade: string;
  className: string;
  studentData: StudentData;
  onBack: () => void;
}) {
  // State for tab management
  const [activeTab, setActiveTab] = useState('all');
  const [currentExam, setCurrentExam] = useState(allExamsData[0]); // Start with LGS 8 (most recent)
  const [showExamDropdown, setShowExamDropdown] = useState(false);
  const [activeSubjectTab, setActiveSubjectTab] = useState('MATEMATİK');
  const [selectedTopicSubject, setSelectedTopicSubject] = useState('MATEMATİK');
  const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);
  // Function to get topics for the active subject
  const getTopicsForActiveSubject = () => {
    const subject = currentExam.subjects.find(s => s.subject === activeSubjectTab);
    if (!subject || !subject.topics || subject.topics.length === 0) {
      return [];
    }
    // Map the topics to include success rate
    return subject.topics.map(topic => ({
      ...topic,
      successRate: topic.questions > 0 ? topic.net / topic.questions * 100 : 0
    }));
  };
  return <div className="space-y-6" data-id="element-172">
      {/* Sabit Header - Değiştirilemeyen */}
      <div className="flex items-center gap-4 mb-6" data-id="element-173">
        <button onClick={onBack} className="flex items-center gap-2 px-4 py-2 rounded-lg border border-white text-white hover:bg-white/10 transition-all" data-id="element-174">
          <ArrowLeft className="w-5 h-5" data-id="element-175" />
          {className} Sınıfı
        </button>
        {/* SABİT GÖRÜNÜM - Dropdown YOK */}
        <div className="flex items-center gap-3" data-id="element-176">
          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-emerald-600 to-teal-600 flex items-center justify-center" data-id="element-177">
            <span className="text-white font-bold" data-id="element-178">{studentData.name[0]}</span>
          </div>
          <div data-id="element-179">
            <h1 className="text-2xl font-bold text-white" data-id="element-180">
              {studentData.name} - Sınav Analizleri
            </h1>
            <p className="text-gray-400" data-id="element-181">
              {className} • No: {studentData.number} • Toplam{' '}
              {studentData.totalExams} Deneme
            </p>
          </div>
        </div>
      </div>
      {/* Tab Navigation - EMERALD TEMA */}
      <div className="p-[1px] rounded-lg bg-gradient-to-r from-emerald-800 to-emerald-600" data-id="element-182">
        <div className="p-1 bg-black/90 rounded-lg" data-id="element-183">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-1" data-id="element-184">
            <button onClick={() => setActiveTab('all')} className={`px-4 py-2 rounded-lg transition-colors ${activeTab === 'all' ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white' : 'bg-black/60 text-gray-400 hover:bg-black/40'}`} data-id="element-185">
              Tüm Denemeler
            </button>
            <button onClick={() => setActiveTab('last')} className={`px-4 py-2 rounded-lg transition-colors ${activeTab === 'last' ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white' : 'bg-black/60 text-gray-400 hover:bg-black/40'}`} data-id="element-186">
              Son Deneme
            </button>
            <button onClick={() => setActiveTab('topic')} className={`px-4 py-2 rounded-lg transition-colors ${activeTab === 'topic' ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white' : 'bg-black/60 text-gray-400 hover:bg-black/40'}`} data-id="element-187">
              Konu Bazlı Genel Analiz
            </button>
          </div>
        </div>
      </div>
      {/* Tab Content */}
      {activeTab === 'all' && <div className="space-y-6" data-id="element-188">
          {/* Genel İstatistikler - EMERALD TEMA */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-189">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-190">
              <h2 className="text-xl font-bold mb-4" data-id="element-191">Genel İstatistikler</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-192">
                {/* Toplam Deneme */}
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-193">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-194">
                    <div className="text-sm text-gray-400" data-id="element-195">Toplam Deneme</div>
                    <div className="text-2xl font-bold text-white" data-id="element-196">
                      {studentData.totalExams}
                    </div>
                  </div>
                </div>
                {/* Ortalama Net */}
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-197">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-198">
                    <div className="text-sm text-gray-400" data-id="element-199">Ortalama Net</div>
                    <div className="text-2xl font-bold text-white" data-id="element-200">
                      {studentData.averageNet.toFixed(2)}
                    </div>
                  </div>
                </div>
                {/* En Yüksek Net */}
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-201">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-202">
                    <div className="text-sm text-gray-400" data-id="element-203">En Yüksek Net</div>
                    <div className="text-2xl font-bold text-white" data-id="element-204">
                      {studentData.highestNet}
                    </div>
                  </div>
                </div>
                {/* En Düşük Net */}
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-205">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-206">
                    <div className="text-sm text-gray-400" data-id="element-207">En Düşük Net</div>
                    <div className="text-2xl font-bold text-white" data-id="element-208">
                      {studentData.lowestNet}
                    </div>
                  </div>
                </div>
                {/* En Başarılı Ders */}
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-209">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-210">
                    <div className="text-sm text-gray-400" data-id="element-211">
                      En Başarılı Ders
                    </div>
                    <div className="text-2xl font-bold text-white" data-id="element-212">
                      {studentData.strongestSubject}
                    </div>
                  </div>
                </div>
                {/* En Zayıf Ders */}
                <div className="p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-213">
                  <div className="p-4 bg-black/95 rounded-lg" data-id="element-214">
                    <div className="text-sm text-gray-400" data-id="element-215">En Zayıf Ders</div>
                    <div className="text-2xl font-bold text-white" data-id="element-216">
                      {studentData.weakestSubject}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Deneme Sınavı Sonuçları Grafiği - 10'ar aralıklı Y ekseni */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-217">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-218">
              <h2 className="text-xl font-bold mb-4" data-id="element-219">
                Deneme Sınavı Sonuçları
              </h2>
              <div className="h-80" data-id="element-220">
                <ResponsiveContainer width="100%" height="100%" data-id="element-221">
                  <RechartsLineChart data={lgsExamData} data-id="element-222">
                    <CartesianGrid strokeDasharray="3 3" stroke="#333" data-id="element-223" />
                    <XAxis dataKey="name" stroke="#999" data-id="element-224" />
                    <YAxis stroke="#999" domain={[0, 90]} ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90]} tickCount={10} data-id="element-225" />
                    <Tooltip content={CustomTooltip} data-id="element-226" />
                    <Legend data-id="element-227" />
                    <Line type="monotone" dataKey="net" name="Net" stroke="#10b981" strokeWidth={2} dot={{
                  r: 6
                }} activeDot={{
                  r: 8
                }} data-id="element-228" />
                  </RechartsLineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
          {/* En Çok Hata Yapılan Konular - 6 DERS TAM LİSTE */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-229">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-230">
              <h2 className="text-xl font-bold mb-6" data-id="element-231">
                En Çok Hata Yapılan Konular
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-232">
                {/* MATEMATİK Kartı */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-400" data-id="element-233">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-234">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-235">
                      MATEMATİK
                    </h3>
                    <div className="space-y-4" data-id="element-236">
                      <div className="space-y-2" data-id="element-237">
                        <span className="text-gray-300 font-medium" data-id="element-238">
                          Eşitsizlikler
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-239">
                          <span className="text-red-400" data-id="element-240">6 Yanlış</span>
                          <span className="text-gray-400" data-id="element-241">Başarı: 66.7%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-242">
                          <div className="h-full bg-gradient-to-r from-blue-600 to-blue-400" style={{
                        width: '66.7%'
                      }} data-id="element-243" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-244">
                        <span className="text-gray-300 font-medium" data-id="element-245">
                          Dönüşüm Geometrisi
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-246">
                          <span className="text-red-400" data-id="element-247">5 Yanlış</span>
                          <span className="text-gray-400" data-id="element-248">Başarı: 66.7%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-249">
                          <div className="h-full bg-gradient-to-r from-blue-600 to-blue-400" style={{
                        width: '66.7%'
                      }} data-id="element-250" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-251">
                        <span className="text-gray-300 font-medium" data-id="element-252">
                          Cebirsel İfadeler
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-253">
                          <span className="text-red-400" data-id="element-254">9 Yanlış</span>
                          <span className="text-gray-400" data-id="element-255">Başarı: 75.0%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-256">
                          <div className="h-full bg-gradient-to-r from-blue-600 to-blue-400" style={{
                        width: '75.0%'
                      }} data-id="element-257" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* TÜRKÇE Kartı */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-red-600 to-red-400" data-id="element-258">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-259">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-260">
                      TÜRKÇE
                    </h3>
                    <div className="space-y-4" data-id="element-261">
                      <div className="space-y-2" data-id="element-262">
                        <span className="text-gray-300 font-medium" data-id="element-263">
                          Anlatım Bozukluğu
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-264">
                          <span className="text-red-400" data-id="element-265">9 Yanlış</span>
                          <span className="text-gray-400" data-id="element-266">Başarı: 58.3%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-267">
                          <div className="h-full bg-gradient-to-r from-red-600 to-red-400" style={{
                        width: '58.3%'
                      }} data-id="element-268" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-269">
                        <span className="text-gray-300 font-medium" data-id="element-270">
                          Cümle Türleri
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-271">
                          <span className="text-red-400" data-id="element-272">7 Yanlış</span>
                          <span className="text-gray-400" data-id="element-273">Başarı: 68.8%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-274">
                          <div className="h-full bg-gradient-to-r from-red-600 to-red-400" style={{
                        width: '68.8%'
                      }} data-id="element-275" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-276">
                        <span className="text-gray-300 font-medium" data-id="element-277">
                          Fiilimsiler
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-278">
                          <span className="text-red-400" data-id="element-279">6 Yanlış</span>
                          <span className="text-gray-400" data-id="element-280">Başarı: 62.5%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-281">
                          <div className="h-full bg-gradient-to-r from-red-600 to-red-400" style={{
                        width: '62.5%'
                      }} data-id="element-282" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* FEN BİLİMLERİ Kartı */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-green-600 to-green-400" data-id="element-283">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-284">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-285">
                      FEN BİLİMLERİ
                    </h3>
                    <div className="space-y-4" data-id="element-286">
                      <div className="space-y-2" data-id="element-287">
                        <span className="text-gray-300 font-medium" data-id="element-288">
                          Madde ve Endüstri
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-289">
                          <span className="text-red-400" data-id="element-290">10 Yanlış</span>
                          <span className="text-gray-400" data-id="element-291">Başarı: 72.7%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-292">
                          <div className="h-full bg-gradient-to-r from-green-600 to-green-400" style={{
                        width: '72.7%'
                      }} data-id="element-293" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-294">
                        <span className="text-gray-300 font-medium" data-id="element-295">
                          Elektrik Yükleri
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-296">
                          <span className="text-red-400" data-id="element-297">7 Yanlış</span>
                          <span className="text-gray-400" data-id="element-298">Başarı: 77.8%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-299">
                          <div className="h-full bg-gradient-to-r from-green-600 to-green-400" style={{
                        width: '77.8%'
                      }} data-id="element-300" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-301">
                        <span className="text-gray-300 font-medium" data-id="element-302">
                          Basınç
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-303">
                          <span className="text-red-400" data-id="element-304">4 Yanlış</span>
                          <span className="text-gray-400" data-id="element-305">Başarı: 75.0%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-306">
                          <div className="h-full bg-gradient-to-r from-green-600 to-green-400" style={{
                        width: '75.0%'
                      }} data-id="element-307" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* T.C. İNKILAP TARİHİ Kartı */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-amber-600 to-amber-400" data-id="element-308">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-309">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-310">
                      T.C. İNKILAP TARİHİ
                    </h3>
                    <div className="space-y-4" data-id="element-311">
                      <div className="space-y-2" data-id="element-312">
                        <span className="text-gray-300 font-medium" data-id="element-313">
                          Atatürk Dönemi Dış Politika
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-314">
                          <span className="text-red-400" data-id="element-315">6 Yanlış</span>
                          <span className="text-gray-400" data-id="element-316">Başarı: 66.7%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-317">
                          <div className="h-full bg-gradient-to-r from-amber-600 to-amber-400" style={{
                        width: '66.7%'
                      }} data-id="element-318" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-319">
                        <span className="text-gray-300 font-medium" data-id="element-320">
                          Milli Bir Destan
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-321">
                          <span className="text-red-400" data-id="element-322">6 Yanlış</span>
                          <span className="text-gray-400" data-id="element-323">Başarı: 83.3%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-324">
                          <div className="h-full bg-gradient-to-r from-amber-600 to-amber-400" style={{
                        width: '83.3%'
                      }} data-id="element-325" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-326">
                        <span className="text-gray-300 font-medium" data-id="element-327">
                          Milli Uyanış
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-328">
                          <span className="text-red-400" data-id="element-329">4 Yanlış</span>
                          <span className="text-gray-400" data-id="element-330">Başarı: 85.0%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-331">
                          <div className="h-full bg-gradient-to-r from-amber-600 to-amber-400" style={{
                        width: '85.0%'
                      }} data-id="element-332" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* DİN KÜLTÜRÜ Kartı */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-teal-600 to-teal-400" data-id="element-333">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-334">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-335">
                      DİN KÜLTÜRÜ
                    </h3>
                    <div className="space-y-4" data-id="element-336">
                      <div className="space-y-2" data-id="element-337">
                        <span className="text-gray-300 font-medium" data-id="element-338">
                          İslam Dinine Göre Kötü Davranışlar
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-339">
                          <span className="text-red-400" data-id="element-340">5 Yanlış</span>
                          <span className="text-gray-400" data-id="element-341">Başarı: 66.7%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-342">
                          <div className="h-full bg-gradient-to-r from-teal-600 to-teal-400" style={{
                        width: '66.7%'
                      }} data-id="element-343" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-344">
                        <span className="text-gray-300 font-medium" data-id="element-345">
                          Hac İbadeti
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-346">
                          <span className="text-red-400" data-id="element-347">3 Yanlış</span>
                          <span className="text-gray-400" data-id="element-348">Başarı: 66.7%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-349">
                          <div className="h-full bg-gradient-to-r from-teal-600 to-teal-400" style={{
                        width: '66.7%'
                      }} data-id="element-350" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-351">
                        <span className="text-gray-300 font-medium" data-id="element-352">
                          Kur'an-ı Kerim
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-353">
                          <span className="text-red-400" data-id="element-354">3 Yanlış</span>
                          <span className="text-gray-400" data-id="element-355">Başarı: 83.3%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-356">
                          <div className="h-full bg-gradient-to-r from-teal-600 to-teal-400" style={{
                        width: '83.3%'
                      }} data-id="element-357" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* İNGİLİZCE Kartı */}
                <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-purple-400" data-id="element-358">
                  <div className="p-4 bg-black/95 rounded-xl h-full" data-id="element-359">
                    <h3 className="text-lg font-bold mb-4 border-b border-gray-800 pb-2" data-id="element-360">
                      İNGİLİZCE
                    </h3>
                    <div className="space-y-4" data-id="element-361">
                      <div className="space-y-2" data-id="element-362">
                        <span className="text-gray-300 font-medium" data-id="element-363">
                          The Internet
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-364">
                          <span className="text-red-400" data-id="element-365">4 Yanlış</span>
                          <span className="text-gray-400" data-id="element-366">Başarı: 83.3%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-367">
                          <div className="h-full bg-gradient-to-r from-purple-600 to-purple-400" style={{
                        width: '83.3%'
                      }} data-id="element-368" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-369">
                        <span className="text-gray-300 font-medium" data-id="element-370">
                          Science
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-371">
                          <span className="text-red-400" data-id="element-372">4 Yanlış</span>
                          <span className="text-gray-400" data-id="element-373">Başarı: 81.5%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-374">
                          <div className="h-full bg-gradient-to-r from-purple-600 to-purple-400" style={{
                        width: '81.5%'
                      }} data-id="element-375" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-376">
                        <span className="text-gray-300 font-medium" data-id="element-377">
                          Adventures
                        </span>
                        <div className="flex justify-between items-center text-sm" data-id="element-378">
                          <span className="text-red-400" data-id="element-379">3 Yanlış</span>
                          <span className="text-gray-400" data-id="element-380">Başarı: 80.0%</span>
                        </div>
                        <div className="w-full h-1.5 bg-gray-800 rounded-full overflow-hidden" data-id="element-381">
                          <div className="h-full bg-gradient-to-r from-purple-600 to-purple-400" style={{
                        width: '80.0%'
                      }} data-id="element-382" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {activeTab === 'last' && <div className="space-y-6" data-id="element-383">
          {/* Son Deneme Özeti - En son deneme */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-384">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-385">
              <div className="flex flex-col md:flex-row justify-between md:items-center mb-6" data-id="element-386">
                {/* Sınav Seçimi Dropdown - LGS 8'den başlar */}
                <div className="relative" data-id="element-387">
                  <button onClick={() => setShowExamDropdown(!showExamDropdown)} className="flex items-center gap-2 px-4 py-2 bg-white/5 rounded-lg hover:bg-white/10 transition-colors" data-id="element-388">
                    <span className="text-xl font-bold" data-id="element-389">
                      {currentExam.name}
                    </span>
                    <span className="text-gray-400" data-id="element-390">
                      {new Date(currentExam.date).toLocaleDateString('tr-TR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                    </span>
                    <ChevronDown className={`w-5 h-5 transition-transform ${showExamDropdown ? 'rotate-180' : ''}`} data-id="element-391" />
                  </button>
                  {showExamDropdown && <div className="absolute top-full left-0 mt-1 z-10 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto" data-id="element-392">
                      {allExamsData.map(exam => <button key={exam.id} onClick={() => {
                  setCurrentExam(exam);
                  setShowExamDropdown(false);
                }} className="w-full text-left px-4 py-2 hover:bg-emerald-500/20 transition-colors flex justify-between items-center" data-id="element-393">
                          <span data-id="element-394">{exam.name}</span>
                          <span className="text-sm text-gray-400" data-id="element-395">
                            {new Date(exam.date).toLocaleDateString('tr-TR', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric'
                    })}
                          </span>
                        </button>)}
                    </div>}
                </div>
              </div>
              {/* PieChart - Net değerleri göster, yüzde değil */}
              <div className="flex flex-col items-center" data-id="element-396">
                <div className="h-80 w-full max-w-md" data-id="element-397">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-398">
                    <PieChart data-id="element-399">
                      <Pie data={[{
                    name: 'Doğru',
                    value: currentExam.totalCorrect,
                    color: '#4ade80'
                  }, {
                    name: 'Yanlış',
                    value: currentExam.totalWrong,
                    color: '#f87171'
                  }, {
                    name: 'Boş',
                    value: currentExam.totalEmpty,
                    color: '#94a3b8'
                  }]} cx="50%" cy="50%" innerRadius={80} outerRadius={120} paddingAngle={5} dataKey="value" label={({
                    name,
                    value
                  }) => `${name}: ${value}`} labelLine={false} data-id="element-400">
                        <Cell fill="#4ade80" data-id="element-401" />
                        <Cell fill="#f87171" data-id="element-402" />
                        <Cell fill="#94a3b8" data-id="element-403" />
                      </Pie>
                      <Tooltip formatter={(value, name) => [value, name]} data-id="element-404" />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
                {/* Stats below chart - Seçilen denemeye göre dinamik */}
                <div className="mt-4 grid grid-cols-4 gap-8" data-id="element-405">
                  <div className="flex flex-col items-center" data-id="element-406">
                    <span className="text-sm text-gray-400" data-id="element-407">Toplam Net</span>
                    <span className="text-2xl font-bold text-white" data-id="element-408">
                      {currentExam.totalNet}
                    </span>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-409">
                    <span className="text-sm text-gray-400" data-id="element-410">Doğru</span>
                    <span className="text-2xl font-bold text-green-500" data-id="element-411">
                      {currentExam.totalCorrect}
                    </span>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-412">
                    <span className="text-sm text-gray-400" data-id="element-413">Yanlış</span>
                    <span className="text-2xl font-bold text-red-500" data-id="element-414">
                      {currentExam.totalWrong}
                    </span>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-415">
                    <span className="text-sm text-gray-400" data-id="element-416">Boş</span>
                    <span className="text-2xl font-bold text-gray-500" data-id="element-417">
                      {currentExam.totalEmpty}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Ders Bazlı Analiz Tablosu */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-418">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-419">
              <h2 className="text-xl font-bold mb-4" data-id="element-420">Ders Bazlı Analiz</h2>
              <div className="overflow-x-auto" data-id="element-421">
                <table className="w-full" data-id="element-422">
                  <thead data-id="element-423">
                    <tr className="border-b border-gray-800" data-id="element-424">
                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-400" data-id="element-425">
                        Ders
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-426">
                        Doğru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-427">
                        Yanlış
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-428">
                        Boş
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-429">
                        Net
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-430">
                        Başarı
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-431">
                    {currentExam.subjects.map((subject, index) => {
                  const gradientClass = DERS_RENKLERI[subject.subject] || 'from-emerald-600 to-emerald-400';
                  const successRate = subject.questions > 0 ? subject.net / subject.questions * 100 : 0;
                  return <tr key={index} className="border-b border-gray-800" data-id="element-432">
                          <td className="px-4 py-3 text-sm font-medium text-white" data-id="element-433">
                            {subject.subject}
                          </td>
                          <td className="px-4 py-3 text-center text-sm text-green-500" data-id="element-434">
                            {subject.correct}
                          </td>
                          <td className="px-4 py-3 text-center text-sm text-red-500" data-id="element-435">
                            {subject.wrong}
                          </td>
                          <td className="px-4 py-3 text-center text-sm text-gray-500" data-id="element-436">
                            {subject.empty}
                          </td>
                          <td className="px-4 py-3 text-center text-sm text-white" data-id="element-437">
                            {subject.net.toFixed(2)}
                          </td>
                          <td className="px-4 py-3" data-id="element-438">
                            <div className="flex items-center gap-2 justify-end" data-id="element-439">
                              <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-440">
                                <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                            width: `${successRate}%`
                          }} data-id="element-441" />
                              </div>
                              <span className="text-xs text-white min-w-[45px] text-right" data-id="element-442">
                                {successRate.toFixed(1)}%
                              </span>
                            </div>
                          </td>
                        </tr>;
                })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* Konu Analizi Tablosu - Updated for all subjects */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-443">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-444">
              <h2 className="text-xl font-bold mb-6" data-id="element-445">Konu Analizi</h2>
              {/* Konu Analizi Dropdown */}
              <div className="flex justify-center mb-6" data-id="element-446">
                <div className="relative w-full max-w-xs" data-id="element-447">
                  <button onClick={() => setShowSubjectDropdown(!showSubjectDropdown)} className="w-full flex items-center justify-between gap-2 px-4 py-3 bg-black/80 rounded-lg border border-emerald-500/30 hover:border-emerald-500/50 transition-colors" data-id="element-448">
                    <span className="text-white" data-id="element-449">{activeSubjectTab}</span>
                    <ChevronDown className={`w-5 h-5 text-emerald-400 transition-transform ${showSubjectDropdown ? 'rotate-180' : ''}`} data-id="element-450" />
                  </button>
                  {showSubjectDropdown && <div className="absolute top-full left-0 mt-1 z-10 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto" data-id="element-451">
                      {currentExam.subjects.map(subject => {
                  const isSelected = activeSubjectTab === subject.subject;
                  return <button key={subject.subject} onClick={() => {
                    setActiveSubjectTab(subject.subject);
                    setShowSubjectDropdown(false);
                  }} className={`w-full text-left px-4 py-2 transition-colors ${isSelected ? 'bg-emerald-500/20 text-emerald-400' : 'text-white hover:bg-emerald-500/10'}`} data-id="element-452">
                            {subject.subject}
                          </button>;
                })}
                    </div>}
                </div>
              </div>
              {/* Konu Listesi - Seçilen Derse Göre */}
              <div className="overflow-x-auto" data-id="element-453">
                <table className="w-full" data-id="element-454">
                  <thead data-id="element-455">
                    <tr className="border-b border-gray-800" data-id="element-456">
                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-400" data-id="element-457">
                        Konu
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-458">
                        Doğru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-459">
                        Yanlış
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-460">
                        Boş
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-461">
                        Net
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-462">
                        Başarı
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-463">
                    {getTopicsForActiveSubject().map((topic, index) => {
                  const gradientClass = DERS_RENKLERI[activeSubjectTab] || 'from-emerald-600 to-teal-600';
                  return <tr key={index} className="border-b border-gray-800" data-id="element-464">
                          <td className="px-4 py-3 text-sm font-medium text-white" data-id="element-465">
                            {topic.topic}
                          </td>
                          <td className="px-4 py-3 text-center text-sm text-green-500" data-id="element-466">
                            {topic.correct}
                          </td>
                          <td className="px-4 py-3 text-center text-sm text-red-500" data-id="element-467">
                            {topic.wrong}
                          </td>
                          <td className="px-4 py-3 text-center text-sm text-gray-500" data-id="element-468">
                            {topic.empty}
                          </td>
                          <td className="px-4 py-3 text-center text-sm text-white" data-id="element-469">
                            {topic.net?.toFixed(2) || '0.00'}
                          </td>
                          <td className="px-4 py-3" data-id="element-470">
                            <div className="flex items-center gap-2 justify-end" data-id="element-471">
                              <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-472">
                                <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                            width: `${topic.successRate}%`
                          }} data-id="element-473" />
                              </div>
                              <span className="text-xs text-white min-w-[45px] text-right" data-id="element-474">
                                {topic.successRate.toFixed(1)}%
                              </span>
                            </div>
                          </td>
                        </tr>;
                })}
                    {/* Konu bulunamadığında */}
                    {getTopicsForActiveSubject().length === 0 && <tr data-id="element-475">
                        <td colSpan={6} className="px-4 py-8 text-center text-gray-400" data-id="element-476">
                          Bu ders için konu analizi bulunmuyor.
                        </td>
                      </tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
      {activeTab === 'topic' && <div className="space-y-6" data-id="element-477">
          {/* Konu Bazlı Analiz - EMERALD TEMA - Updated for all subjects */}
          <div className="p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-478">
            <div className="p-6 bg-black/90 rounded-xl" data-id="element-479">
              <h2 className="text-xl font-bold mb-4" data-id="element-480">
                Konu Bazlı Genel Analiz
              </h2>
              {/* Ders Seçimi */}
              <div className="flex justify-center mb-6" data-id="element-481">
                <div className="relative w-full max-w-xs" data-id="element-482">
                  <button onClick={() => setShowSubjectDropdown(!showSubjectDropdown)} className="w-full flex items-center justify-between gap-2 px-4 py-3 bg-black/80 rounded-lg border border-emerald-500/30 hover:border-emerald-500/50 transition-colors" data-id="element-483">
                    <span className="text-white" data-id="element-484">{selectedTopicSubject}</span>
                    <ChevronDown className={`w-5 h-5 text-emerald-400 transition-transform ${showSubjectDropdown ? 'rotate-180' : ''}`} data-id="element-485" />
                  </button>
                  {showSubjectDropdown && <div className="absolute top-full left-0 mt-1 z-10 w-full bg-gray-900/95 border border-gray-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto" data-id="element-486">
                      {Object.keys(topicAnalysisData).map(subject => <button key={subject} onClick={() => {
                  setSelectedTopicSubject(subject);
                  setShowSubjectDropdown(false);
                }} className="w-full text-left px-4 py-2 hover:bg-emerald-500/20 transition-colors" data-id="element-487">
                          {subject}
                        </button>)}
                    </div>}
                </div>
              </div>
              {/* Konu Bazlı Genel Analiz - Kümülatif Veri */}
              <div className="overflow-x-auto" data-id="element-488">
                <table className="w-full" data-id="element-489">
                  <thead data-id="element-490">
                    <tr className="border-b border-gray-800" data-id="element-491">
                      <th className="px-4 py-3 text-left text-sm font-medium text-gray-400" data-id="element-492">
                        Konu
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-493">
                        Doğru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-494">
                        Yanlış
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-495">
                        Boş
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-496">
                        Toplam Soru
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium text-gray-400" data-id="element-497">
                        Başarı
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-498">
                    {topicAnalysisData[selectedTopicSubject].map((topic, index) => {
                  const gradientClass = DERS_RENKLERI[selectedTopicSubject] || 'from-emerald-600 to-teal-600';
                  return <tr key={index} className="border-b border-gray-800" data-id="element-499">
                            <td className="px-4 py-3 text-sm font-medium text-white" data-id="element-500">
                              {topic.topic}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-green-500" data-id="element-501">
                              {topic.correct}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-red-500" data-id="element-502">
                              {topic.wrong}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-gray-500" data-id="element-503">
                              {topic.empty}
                            </td>
                            <td className="px-4 py-3 text-center text-sm text-white" data-id="element-504">
                              {topic.totalQuestions}
                            </td>
                            <td className="px-4 py-3" data-id="element-505">
                              <div className="flex items-center gap-2 justify-end" data-id="element-506">
                                <div className="w-32 h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-507">
                                  <div className={`h-full bg-gradient-to-r ${gradientClass}`} style={{
                            width: `${topic.accuracy}%`
                          }} data-id="element-508" />
                                </div>
                                <span className="text-xs text-white min-w-[45px] text-right" data-id="element-509">
                                  {topic.accuracy.toFixed(1)}%
                                </span>
                              </div>
                            </td>
                          </tr>;
                })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}
// Main ExamAnalysis Component
const ExamAnalysis = () => {
  const [viewState, setViewState] = useState<'grades' | 'classes' | 'students' | 'analysis'>('grades');
  const [selectedGrade, setSelectedGrade] = useState<string>('8. Sınıf');
  const [selectedClass, setSelectedClass] = useState<string>('');
  const [selectedStudent, setSelectedStudent] = useState<StudentData | null>(null);
  // Handle grade selection
  const handleGradeSelect = (grade: string, className?: string) => {
    setSelectedGrade(grade);
    if (className) {
      setSelectedClass(className);
      setViewState('students');
    } else {
      setViewState('classes');
    }
  };
  // Handle back navigation from class students to class list
  const handleBackToClasses = () => {
    setViewState('classes');
  };
  // Handle student selection
  const handleStudentSelect = (student: StudentData) => {
    setSelectedStudent(student);
    setViewState('analysis');
  };
  // Handle back navigation from student analysis to class students
  const handleBackToStudents = () => {
    setViewState('students');
  };
  // Render the appropriate view based on the current state
  return <div className="space-y-6 bg-black min-h-screen" data-id="element-510">
      {viewState === 'grades' && <GradeSelection onGradeSelect={handleGradeSelect} data-id="element-511" />}
      {viewState === 'classes' && <GradeSelection onGradeSelect={handleGradeSelect} data-id="element-512" />}
      {viewState === 'students' && selectedClass && <ClassStudents grade={selectedGrade} className={selectedClass} classData={allClassData[selectedGrade][selectedClass]} onBack={handleBackToClasses} onStudentSelect={handleStudentSelect} data-id="element-513" />}
      {viewState === 'analysis' && selectedStudent && <StudentDetailedAnalysis grade={selectedGrade} className={selectedClass} studentData={selectedStudent} onBack={handleBackToStudents} data-id="element-514" />}
    </div>;
};
export default ExamAnalysis;